module.exports = __webpack_public_path__ + "static/img/yyapp.da91e51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yyapp.png
// module id = Sdpe
// module chunks = 15